// ============================================
// БЛОК 12: СЛАЙДЕР ЦЕН И УПРАВЛЕНИЕ ЦЕНАМИ
// ============================================
// Код блока 12 вынесен из script.js
// Включает: переключение цен по кампусам, обновление цен, бесконечный слайдер на мобильных

// Единый маппинг названий кампусов RU и EN -> slug (для определения кампуса по тексту)
const BLOCK12_CAMPUS_MAP = {
  'Сколково': 'skolkovo', 'Skolkovo': 'skolkovo',
  'Москва': 'moscow', 'Moscow': 'moscow',
  'Горки': 'gorki', 'Gorki': 'gorki',
  'Санкт-Петербург': 'spb', 'St. Petersburg': 'spb', 'Saint Petersburg': 'spb',
  'Ташкент': 'tashkent', 'Tashkent': 'tashkent'
};

function getBlock12CampusSlug(campusText) {
  if (!campusText || typeof campusText !== 'string') return null;
  const trimmed = campusText.trim();
  const key = Object.keys(BLOCK12_CAMPUS_MAP).find(k => trimmed.includes(k));
  return key ? BLOCK12_CAMPUS_MAP[key] : null;
}

// Разбиваем плоский массив campusPrices на группы по последовательным category_id.
// Каждая группа — набор строк цен, которые показываются в одной карточке.
function block12SplitIntoGroups(campusPrices) {
  const groups = [];
  let currentCatId = null;
  let currentGroup = [];
  (campusPrices || []).forEach(p => {
    const cid = p.category_id;
    if (cid !== currentCatId && currentGroup.length > 0) {
      groups.push(currentGroup);
      currentGroup = [];
    }
    currentCatId = cid;
    currentGroup.push(p);
  });
  if (currentGroup.length > 0) groups.push(currentGroup);
  return groups;
}

// Соответствие category_id (fee_category) → строки цен из CMS. Карточки в DOM имеют data-category-id.
function block12GroupsByCategoryId(campusPrices) {
  const map = Object.create(null);
  block12SplitIntoGroups(campusPrices).forEach(function (group) {
    if (!group || !group.length) return;
    const cid = group[0].category_id;
    if (cid == null || cid === '') return;
    map[String(cid)] = group;
  });
  return map;
}

// Функция для синхронизации высот элементов в блоках цен
function syncBlock12PriceHeights() {
  // Список классов элементов, которые нужно синхронизировать
  const elementClasses = [
    'block12_price_title',
    'block12_price_subtitle',
    'block12_price_age',
    'block12_price_age_left',
    'block12_price_age_right',
    'block12_price_with_discount',
    'block12_price_without_discount',
    'block12_price_text'
  ];

  // Сохраняем текущее состояние видимости всех блоков
  const allPriceItems = document.querySelectorAll('.block12_price_item');
  const visibilityStates = [];
  allPriceItems.forEach((item, index) => {
    visibilityStates[index] = {
      display: item.style.display || window.getComputedStyle(item).display,
      item: item
    };
    // Временно показываем все для измерения
    if (visibilityStates[index].display === 'none') {
      item.style.display = 'block';
      item.style.opacity = '0';
      item.style.position = 'absolute';
      item.style.left = '-9999px';
    }
  });

  elementClasses.forEach(className => {
    // Находим все элементы этого типа
    const allElements = document.querySelectorAll(`.${className}`);
    
    if (allElements.length === 0) return;

    // Сбрасываем высоту для корректного измерения
    allElements.forEach(el => {
      el.style.height = 'auto';
    });

    // Находим максимальную высоту среди всех элементов
    let maxHeight = 0;
    allElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Применяем максимальную высоту ко всем элементам
    allElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  });

  // Восстанавливаем видимость блоков
  visibilityStates.forEach(state => {
    if (state.display === 'none') {
      state.item.style.display = 'none';
      state.item.style.opacity = '';
      state.item.style.position = '';
      state.item.style.left = '';
    } else {
      state.item.style.display = state.display;
    }
  });
}

// Функция для переключения видимости цен
function toggleBlock12Prices(campus, year = null) {
  // Получаем текущий выбранный год, если не передан
  if (!year) {
    const selectedYear = document.getElementById('block12SelectedYear');
    if (selectedYear) {
      const yearText = selectedYear.textContent.trim();
      const yearMatch = yearText.match(/(\d{4}-\d{4})/);
      if (yearMatch) {
        year = yearMatch[1];
      }
    }
    // Если год не найден, используем год из CMS (block12CurrentYear)
    if (!year) {
      year = window.block12CurrentYear || '2025-2026';
    }
  }
  
  // Данные по выбранному периоду/кампусу: используем их, чтобы скрывать карточки,
  // у которых нет цен в CMS (а не показывать "пустые" карточки).
  const yearData = (block12PricesData && year) ? (block12PricesData[year] || {}) : {};
  const campusPrices = (yearData && Array.isArray(yearData[campus])) ? yearData[campus] : [];
  
  // ВАЖНО: Сначала скрываем ВСЕ информационные блоки, чтобы избежать накопления
  const allInfoBlocks = document.querySelectorAll('.block12_price_info:not(.price-item-clone)');
  allInfoBlocks.forEach(block => {
    block.style.display = 'none';
  });

  // Скрываем все блоки цен (кроме информационного блока block12_price_info)
  const allPriceItems = document.querySelectorAll('.block12_price_item:not(.block12_price_info):not(.price-item-clone)');
  allPriceItems.forEach(item => {
    // Скрываем мобильный информационный блок - он не должен использоваться
    if (item.classList.contains('block12_price_info_mobile')) {
      item.style.display = 'none';
      return;
    }
    item.style.display = 'none';
  });

  // Получаем текущую выбранную категорию на мобильных (если есть)
  let activeCategory = null;
  if (window.innerWidth <= 768) {
    const activeCategoryBtn = document.querySelector('.block12_category_btn_active');
    if (activeCategoryBtn) {
      activeCategory = activeCategoryBtn.getAttribute('data-category');
    }
  }

  const groupsByCategoryId = block12GroupsByCategoryId(campusPrices);

  // Показываем только блоки для выбранного кампуса и года
  const selector = `.block12_price_item[data-campus="${campus}"]:not(.price-item-clone)`;
  const campusPriceItems = document.querySelectorAll(selector);

  campusPriceItems.forEach(item => {
    if (item.classList.contains('block12_price_info')) {
      const itemCampus = item.getAttribute('data-campus');
      if (itemCampus === campus && campusPrices.length > 0) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
      return;
    }

    if (item.classList.contains('block12_price_info_mobile')) {
      item.style.display = 'none';
      return;
    }

    const itemYear = item.getAttribute('data-year');
    const itemCategory = item.getAttribute('data-category');

    const yearMatch = !itemYear || itemYear === year || itemYear.split(',').includes(year);

    let categoryMatch = true;
    if (window.innerWidth <= 768 && activeCategory) {
      categoryMatch = itemCategory === activeCategory;
    }

    const catId = item.getAttribute('data-category-id');
    const hasPricesForCategory = catId && groupsByCategoryId[String(catId)] && groupsByCategoryId[String(catId)].length > 0;

    if (yearMatch && categoryMatch && hasPricesForCategory) {
      item.style.display = 'flex';
    } else {
      item.style.display = 'none';
    }
  });
  
  // Центрируем карусель при 768px, если элементов всего 2
  if (window.innerWidth <= 768) {
    const pricesGrid = document.querySelector('.block12_prices_grid');
    const visibleItems = Array.from(campusPriceItems).filter(item => {
      const itemYear = item.getAttribute('data-year');
      return !itemYear || itemYear === year || itemYear.split(',').includes(year);
    });
    if (pricesGrid && visibleItems.length === 2) {
      pricesGrid.classList.add('block12_prices_grid_centered');
    } else if (pricesGrid) {
      pricesGrid.classList.remove('block12_prices_grid_centered');
    }
  }

  // Убеждаемся, что информационные блоки показываются только для выбранного кампуса
  // Вызываем сразу, без задержки, чтобы избежать мигания
  if (typeof addBlock12InfoItem === 'function') {
    addBlock12InfoItem();
  }
  
  // Синхронизируем высоты после переключения
  setTimeout(() => {
    // Переинициализируем слайдер после изменения видимости (с debounce)
    if (window.innerWidth <= 768 && typeof window.reinitPriceSlider === 'function') {
      if (window.block12ReinitTimeout) {
        clearTimeout(window.block12ReinitTimeout);
      }
      window.block12ReinitTimeout = setTimeout(() => {
        window.reinitPriceSlider();
        window.block12ReinitTimeout = null;
      }, 150);
    }
  }, 10);
}

// Функция добавления информационного блока в конец grid при 768px
// НЕ создаем block12_price_info_mobile - используем существующий block12_price_info из HTML
function addBlock12InfoItem() {
  // Удаляем все существующие мобильные блоки (они не должны использоваться)
  const existingInfoBlocks = document.querySelectorAll('.block12_price_info_mobile');
  existingInfoBlocks.forEach(block => {
    if (block && block.parentNode) {
      block.parentNode.removeChild(block);
    }
  });
  
  // Удаляем все клоны информационных блоков, если они есть
  const clonedInfoBlocks = document.querySelectorAll('.block12_price_info.price-item-clone');
  clonedInfoBlocks.forEach(clone => {
    if (clone && clone.parentNode) {
      clone.parentNode.removeChild(clone);
    }
  });
  
  // Убеждаемся, что block12_price_info из HTML правильно отображается
  const selectedCampus = document.getElementById('block12SelectedCampus');
  if (!selectedCampus) return;
  
  const campusText = selectedCampus.textContent.trim();
  const campusId = getBlock12CampusSlug(campusText);
  if (!campusId) return;
  
  // ВАЖНО: Сначала скрываем ВСЕ информационные блоки, чтобы избежать накопления
  // Используем только оригинальные блоки из HTML, не клоны
  const allInfoBlocks = document.querySelectorAll('.block12_price_info:not(.price-item-clone)');
  
  // Сначала скрываем все блоки
  allInfoBlocks.forEach(block => {
    block.style.display = 'none';
  });
  
  // Затем показываем только блоки для выбранного кампуса
  let visibleCount = 0;
  allInfoBlocks.forEach(block => {
    const blockCampus = block.getAttribute('data-campus');
    if (blockCampus === campusId) {
      // Показываем block12_price_info на всех экранах (и мобильных, и десктопе)
      block.style.display = 'flex';
      visibleCount++;
    }
  });
  
  // На десктопе должна быть только одна видимая карточка
  if (window.innerWidth > 768 && visibleCount > 1) {
    // Оставляем видимым только первый блок для выбранного кампуса
    let firstFound = false;
    allInfoBlocks.forEach(block => {
      const blockCampus = block.getAttribute('data-campus');
      if (blockCampus === campusId) {
        if (!firstFound) {
          block.style.display = 'flex';
          firstFound = true;
        } else {
          block.style.display = 'none';
        }
      }
    });
  }
}

// Данные о ценах для каждого года и кампуса
const defaultBlock12PricesData = {
  '2026-2027': {
    skolkovo: [
      { price1: '13 200 €', price2: '14 040 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 740 €', price2: '15 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 680 €', price2: '19 880 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 110 €', price2: '19 110 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 360 €', price2: '20 610 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 900 €', price2: '22 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 420 €', price2: '22 800 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    moscow: [
      { price1: '13 200 €', price2: '14 040 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 740 €', price2: '15 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 680 €', price2: '19 880 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 110 €', price2: '19 110 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 360 €', price2: '20 610 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 900 €', price2: '22 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 420 €', price2: '22 800 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    gorki: [
      { price1: '13 200 €', price2: '14 040 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 740 €', price2: '15 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 680 €', price2: '19 880 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 110 €', price2: '19 110 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 360 €', price2: '20 610 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 900 €', price2: '22 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 420 €', price2: '22 800 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    spb: [
      { price1: '13 200 €', price2: '14 040 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 740 €', price2: '15 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 680 €', price2: '19 880 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 110 €', price2: '19 110 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 360 €', price2: '20 610 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 900 €', price2: '22 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 420 €', price2: '22 800 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    tashkent: [
      { price1: '164 667 000 сумов', price2: '164 667 000 сумов', date1: '', date2: '' },
      { price1: '164 667 000 сумов', price2: '164 667 000 сумов', date1: '', date2: '' },
      { price1: '215 083 000 сумов', price2: '215 083 000 сумов', date1: '', date2: '' },
      { price1: '248 677 000 сумов', price2: '248 677 000 сумов', date1: '', date2: '' },
      { price1: '282 285 000 сумов', price2: '282 285 000 сумов', date1: '', date2: '' },
      { price1: '315 894 000 сумов', price2: '315 894 000 сумов', date1: '', date2: '' },
      { price1: '332 691 000 сумов', price2: '332 691 000 сумов', date1: '', date2: '' }
    ]
  },
  '2025-2026': {
    skolkovo: [
      { price1: '12 840 €', price2: '13 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 380 €', price2: '15 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 320 €', price2: '19 520 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 750 €', price2: '18 750 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 000 €', price2: '20 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 540 €', price2: '21 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 060 €', price2: '22 440 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    moscow: [
      { price1: '12 840 €', price2: '13 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 380 €', price2: '15 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 320 €', price2: '19 520 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 750 €', price2: '18 750 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 000 €', price2: '20 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 540 €', price2: '21 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 060 €', price2: '22 440 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    gorki: [
      { price1: '12 840 €', price2: '13 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 380 €', price2: '15 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 320 €', price2: '19 520 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 750 €', price2: '18 750 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 000 €', price2: '20 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 540 €', price2: '21 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 060 €', price2: '22 440 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    spb: [
      { price1: '12 840 €', price2: '13 680 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 380 €', price2: '15 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 320 €', price2: '19 520 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 750 €', price2: '18 750 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '19 000 €', price2: '20 250 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 540 €', price2: '21 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '21 060 €', price2: '22 440 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    tashkent: [
      { price1: '159 867 000 сумов', price2: '159 867 000 сумов', date1: '', date2: '' },
      { price1: '159 867 000 сумов', price2: '159 867 000 сумов', date1: '', date2: '' },
      { price1: '208 818 000 сумов', price2: '208 818 000 сумов', date1: '', date2: '' },
      { price1: '241 434 000 сумов', price2: '241 434 000 сумов', date1: '', date2: '' },
      { price1: '274 063 500 сумов', price2: '274 063 500 сумов', date1: '', date2: '' },
      { price1: '306 693 000 сумов', price2: '306 693 000 сумов', date1: '', date2: '' },
      { price1: '323 001 000 сумов', price2: '323 001 000 сумов', date1: '', date2: '' }
    ]
  },
  '2024-2025': {
    skolkovo: [
      { price1: '12 480 €', price2: '13 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 020 €', price2: '14 960 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '17 960 €', price2: '19 160 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 390 €', price2: '18 390 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 640 €', price2: '19 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 180 €', price2: '21 530 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 700 €', price2: '22 080 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    moscow: [
      { price1: '12 480 €', price2: '13 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 020 €', price2: '14 960 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '17 960 €', price2: '19 160 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 390 €', price2: '18 390 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 640 €', price2: '19 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 180 €', price2: '21 530 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 700 €', price2: '22 080 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    gorki: [
      { price1: '12 480 €', price2: '13 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 020 €', price2: '14 960 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '17 960 €', price2: '19 160 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 390 €', price2: '18 390 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 640 €', price2: '19 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 180 €', price2: '21 530 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 700 €', price2: '22 080 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    spb: [
      { price1: '12 480 €', price2: '13 320 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '14 020 €', price2: '14 960 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '17 960 €', price2: '19 160 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 390 €', price2: '18 390 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '18 640 €', price2: '19 890 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 180 €', price2: '21 530 €', date1: 'до 30 Июня', date2: 'с 1 Июля' },
      { price1: '20 700 €', price2: '22 080 €', date1: 'до 30 Июня', date2: 'с 1 Июля' }
    ],
    tashkent: [
      { price1: '155 042 000 сумов', price2: '155 042 000 сумов', date1: '', date2: '' },
      { price1: '155 042 000 сумов', price2: '155 042 000 сумов', date1: '', date2: '' },
      { price1: '202 553 000 сумов', price2: '202 553 000 сумов', date1: '', date2: '' },
      { price1: '234 191 000 сумов', price2: '234 191 000 сумов', date1: '', date2: '' },
      { price1: '265 842 000 сумов', price2: '265 842 000 сумов', date1: '', date2: '' },
      { price1: '297 492 000 сумов', price2: '297 492 000 сумов', date1: '', date2: '' },
      { price1: '313 311 000 сумов', price2: '313 311 000 сумов', date1: '', date2: '' }
    ]
  }
};
// Используем только реальные данные из CMS.
// Если для выбранного периода/кампуса данных нет — карточки должны выглядеть пусто.
const block12PricesData = (window.block12PricesData && Object.keys(window.block12PricesData).length > 0)
  ? window.block12PricesData
  : {};

// Возрастные диапазоны берутся из CMS (fee_category.ages), не перезаписываем
function updateBlock12AgeRanges() {
  // Ранее возраст перезаписывался жёстко заданными значениями по региону,
  // из-за чего значение из CMS (например 2-3 для Ташкента) показывалось как 2,5-4.
  // Теперь используется только возраст из CMS, рендеренный сервером.
}

function updateBlock12PricesForYear(year, campus) {
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  
  const pricesData = block12PricesData[year];
  if (!pricesData) return;

  const campusPrices = pricesData[campus];
  if (!campusPrices) return;

  // Получаем все элементы цен для данного кампуса (исключая info блок и мобильный info блок)
  const campusPriceItems = document.querySelectorAll(`.block12_price_item[data-campus="${campus}"]:not(.block12_price_info):not(.block12_price_info_mobile):not(.price-item-clone)`);
  
  // Убеждаемся, что атрибуты категорий установлены
  campusPriceItems.forEach(item => {
    if (!item.getAttribute('data-category')) {
      const titleElement = item.querySelector('.block12_price_title');
      if (titleElement) {
        const titleText = titleElement.textContent.toLowerCase();
        if (titleText.includes('детский сад') || titleText.includes('kindergarten') || titleText.includes('Early Years')) {
          item.setAttribute('data-category', 'kindergarten');
        } else {
          item.setAttribute('data-category', 'school');
        }
      }
    }
  });

  function ensureBlock12DiscountDateEl(priceWrap) {
    let el = priceWrap.querySelector('.block12_price_discount_date');
    if (!el) {
      el = document.createElement('div');
      el.className = 'block12_price_discount_date';
      el.dataset.block12DateDynamic = 'true';
      priceWrap.appendChild(el);
    }
    return el;
  }

  function clearBlock12DiscountDate(priceWrap) {
    const dateEl = priceWrap.querySelector('.block12_price_discount_date');
    if (!dateEl) return;
    dateEl.textContent = '';
    dateEl.removeAttribute('data-date-ru');
    dateEl.removeAttribute('data-date-en');
    if (dateEl.dataset.block12DateDynamic === 'true') {
      dateEl.remove();
    }
  }

  function applyBlock12PriceRow(priceWrap, priceData) {
    const priceEl = priceWrap.querySelector('.block12_price_with_discount');
    if (!priceData) {
      if (priceEl) priceEl.textContent = '';
      clearBlock12DiscountDate(priceWrap);
      return;
    }
    if (priceEl) {
      if (lang === 'en' && campus === 'tashkent') {
        if (priceData.price1.includes('сумов')) {
          const uzsValue = priceData.price1.replace('сумов', 'UZS');
          priceEl.textContent = uzsValue;
          priceEl.dataset.originalValue = uzsValue;
          priceEl.dataset.tashkentProcessed = 'true';
        } else {
          priceEl.textContent = priceData.price1;
          priceEl.dataset.originalValue = priceData.price1;
        }
      } else {
        priceEl.textContent = priceData.price1;
        if (!priceEl.dataset.originalValue) {
          priceEl.dataset.originalValue = priceData.price1;
        }
      }
    }
    const dateText = (
      lang === 'en'
        ? (priceData.date1_en || priceData.date1)
        : (priceData.date1_ru || priceData.date1) || ''
    ).trim();
    if (dateText) {
      const dateEl = ensureBlock12DiscountDateEl(priceWrap);
      dateEl.textContent = dateText;
      if (priceData.date1_ru) dateEl.setAttribute('data-date-ru', priceData.date1_ru);
      if (priceData.date1_en) dateEl.setAttribute('data-date-en', priceData.date1_en);
    } else {
      clearBlock12DiscountDate(priceWrap);
    }
  }

  const groupsByCategoryId = block12GroupsByCategoryId(campusPrices);

  function syncPriceRows(card, groupPrices) {
    const container = card.querySelector('.block12_price_prices');
    if (!container) return;
    let rows = Array.from(container.querySelectorAll('.block12_price_with'));

    while (rows.length < groupPrices.length) {
      const newRow = document.createElement('div');
      newRow.className = 'block12_price_with';
      newRow.dataset.block12Dynamic = 'true';
      const priceEl = document.createElement('div');
      priceEl.className = 'block12_price_with_discount';
      newRow.appendChild(priceEl);
      container.appendChild(newRow);
      rows.push(newRow);
    }

    while (rows.length > groupPrices.length) {
      const last = rows[rows.length - 1];
      if (last.dataset.block12Dynamic === 'true') {
        last.remove();
        rows.pop();
      } else {
        break;
      }
    }

    rows.forEach((row, i) => {
      applyBlock12PriceRow(row, i < groupPrices.length ? groupPrices[i] : null);
    });
  }

  campusPriceItems.forEach((item) => {
    const catId = item.getAttribute('data-category-id');
    const group = catId ? (groupsByCategoryId[String(catId)] || []) : [];
    syncPriceRows(item, group);
  });

  // Обновляем клоны (мобильный слайдер) — тот же category_id, что у оригинала
  const clonedItems = document.querySelectorAll(`.block12_price_item[data-campus="${campus}"].price-item-clone:not(.block12_price_info):not(.block12_price_info_mobile)`);
  clonedItems.forEach((cloneItem) => {
    const cloneCatId = cloneItem.getAttribute('data-category-id');
    const group = cloneCatId ? (groupsByCategoryId[String(cloneCatId)] || []) : [];
    syncPriceRows(cloneItem, group);
  });
  
  // Принудительно обновляем DOM после изменения цен
  if (campusPriceItems.length > 0) {
    void campusPriceItems[0].offsetHeight;
  }
  
  // Обновляем возрастные диапазоны
  updateBlock12AgeRanges();
  
  // Добавляем информационный блок при 768px
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      addBlock12InfoItem();
    }, 50);
  }
  
  // Переводим валюту после обновления цен
  // Для кампуса Ташкент на английской версии цены должны быть в суммах (UZS)
  // Используем уже объявленную переменную lang из начала функции
  const exchangeRate = 100; // Примерный курс: 1 EUR = 100 RUB
  
  // Обновляем originalValue для всех элементов цен ПОСЛЕ обновления цен, но ДО конвертации валют
  // Включая клонированные элементы на мобильной версии
  const allPriceElements = document.querySelectorAll('.block12_price_with_discount');
  allPriceElements.forEach(priceEl => {
    // Проверяем, к какому кампусу относится этот элемент цены
    const priceItem = priceEl.closest('.block12_price_item');
    const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
    const isTashkentPrice = priceCampus === 'tashkent';
    
    const currentText = priceEl.textContent.trim();
    
    // Для Ташкента на английской версии: если originalValue уже содержит UZS, НИКОГДА не перезаписываем его
    if (lang === 'en' && isTashkentPrice && priceEl.dataset.originalValue) {
      const existingOriginal = priceEl.dataset.originalValue;
      // Если уже есть UZS в originalValue, НИКОГДА не перезаписываем
      if (existingOriginal.includes('UZS')) {
        // Не перезаписываем, оставляем существующее значение
        return;
      }
      // Если currentText уже в UZS, но originalValue еще нет - обновляем originalValue на UZS версию
      if (currentText.includes('UZS') && !existingOriginal.includes('UZS')) {
        priceEl.dataset.originalValue = currentText;
        priceEl.dataset.tashkentProcessed = 'true';
        return;
      }
    }
    
    // Для Ташкента на английской версии: если текущий текст в UZS, сохраняем его в originalValue
    if (lang === 'en' && isTashkentPrice && currentText.includes('UZS')) {
      priceEl.dataset.originalValue = currentText;
      priceEl.dataset.tashkentProcessed = 'true';
      return;
    }
    
    // Сохраняем оригинальное значение для других случаев
    priceEl.dataset.originalValue = currentText;
  });
  
  allPriceElements.forEach(priceEl => {
    // Проверяем, к какому кампусу относится этот элемент цены
    const priceItem = priceEl.closest('.block12_price_item');
    const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
    const isTashkentPrice = priceCampus === 'tashkent';
    
    // КРИТИЧЕСКИ ВАЖНО: для Ташкента на английской версии проверяем ТЕКУЩИЙ текст ПЕРЕД всем остальным
    if (lang === 'en' && isTashkentPrice) {
      const currentText = priceEl.textContent.trim();
      
      // Если текущий текст уже в UZS, НИКОГДА не трогаем его
      if (currentText.includes('UZS')) {
        // Сохраняем UZS версию в originalValue и выходим
        priceEl.dataset.originalValue = currentText;
        priceEl.dataset.tashkentProcessed = 'true';
        return; // ВАЖНО: полностью пропускаем конвертацию валют
      }
      
      // Если текущий текст в рублях или евро, это ошибка
      if (currentText.includes('₽') || currentText.includes('€')) {
      }
    }
    
    const originalText = priceEl.dataset.originalValue || priceEl.textContent.trim();
    
    if (lang === 'en') {
      // Для кампуса Ташкент на английской версии оставляем суммы (UZS), не конвертируем в рубли или евро
      if (isTashkentPrice) {
        // Если цена уже обработана и в UZS, не трогаем её
        if (priceEl.dataset.tashkentProcessed === 'true' && originalText.includes('UZS')) {
          priceEl.textContent = originalText;
          return;
        }
        
        // Переводим "сумов" на английский (UZS)
        const sumsMatch = originalText.match(/([\d\s]+)\s*сумов/);
        if (sumsMatch) {
          const sumsAmount = sumsMatch[1].trim();
          const uzsValue = `${sumsAmount} UZS`;
          priceEl.textContent = uzsValue;
          priceEl.dataset.originalValue = uzsValue;
          priceEl.dataset.tashkentProcessed = 'true';
        } else if (originalText.includes('UZS')) {
          // Уже в суммах, оставляем как есть
          priceEl.textContent = originalText;
          priceEl.dataset.originalValue = originalText;
          priceEl.dataset.tashkentProcessed = 'true';
        } else {
          // Если в оригинале рубли или евро, но это Ташкент - НЕ конвертируем
          // Для Ташкента должны быть только суммы, поэтому НЕ устанавливаем рубли/евро
          // Проверяем текущий текст - если он в UZS или "сумов", оставляем его
          const currentText = priceEl.textContent.trim();
          if (currentText.includes('UZS') || currentText.includes('сумов')) {
            // Текущий текст уже правильный, не перезаписываем
            return;
          }
          // Если текущий текст в рублях/евро, не устанавливаем его
          if (currentText.includes('₽') || currentText.includes('€')) {
            return;
          }
          // Если оригинал в рублях/евро, не используем его
          if (originalText.includes('₽') || originalText.includes('€')) {
            return;
          }
          // Только если оригинал не в рублях/евро, используем его
          priceEl.textContent = originalText;
        }
      } else {
        // Для других кампусов переводим рубли в евро
        const rubMatch = originalText.match(/([\d\s]+)\s*₽/);
        if (rubMatch) {
          const rubAmount = parseInt(rubMatch[1].replace(/\s/g, ''));
          const eurAmount = Math.round(rubAmount / exchangeRate);
          // Форматируем с пробелами для тысяч
          const formattedEur = eurAmount.toLocaleString('en-US').replace(/,/g, ' ');
          priceEl.textContent = `${formattedEur} €`;
        } else {
          // Переводим "сумов" на английский (UZS) для других кампусов тоже
          const sumsMatch = originalText.match(/([\d\s]+)\s*сумов/);
          if (sumsMatch) {
            const sumsAmount = sumsMatch[1].trim();
            priceEl.textContent = `${sumsAmount} UZS`;
          }
          // Если уже в евро или других валютах, оставляем как есть
        }
      }
    } else {
      // Для кампуса Ташкент на русской версии оставляем суммы, не конвертируем в рубли
      if (isTashkentPrice) {
        // Переводим "UZS" обратно на "сумов" для русского языка
        const uzsMatch = originalText.match(/([\d\s]+)\s*UZS/);
        if (uzsMatch) {
          const uzsAmount = uzsMatch[1].trim();
          priceEl.textContent = `${uzsAmount} сумов`;
        } else if (originalText.includes('сумов')) {
          // Уже в суммах, оставляем как есть
          priceEl.textContent = originalText;
        } else {
          // Оставляем оригинальное значение
          priceEl.textContent = originalText;
        }
      } else {
        // Для других кампусов: везде евро (рубли убраны, не конвертируем)
        const eurMatch = originalText.match(/([\d\s]+)\s*€/);
        if (eurMatch) {
          const eurAmount = parseInt(eurMatch[1].replace(/\s/g, ''));
          const formattedEur = eurAmount.toLocaleString('ru-RU').replace(/,/g, ' ');
          priceEl.textContent = `${formattedEur} €`;
        } else {
          // Переводим "UZS" обратно на "сумов" для русского языка
          const uzsMatch = originalText.match(/([\d\s]+)\s*UZS/);
          if (uzsMatch) {
            const uzsAmount = uzsMatch[1].trim();
            priceEl.textContent = `${uzsAmount} сумов`;
          } else {
            priceEl.textContent = originalText;
          }
        }
      }
    }
  });
  
  const tDates = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  const block12DiscountDates = document.querySelectorAll('.block12_price_discount_date');
  block12DiscountDates.forEach(dateEl => {
    const ru = dateEl.getAttribute('data-date-ru');
    const en = dateEl.getAttribute('data-date-en');
    if (lang === 'en' && en) {
      dateEl.textContent = en;
      return;
    }
    if (lang === 'ru' && ru) {
      dateEl.textContent = ru;
      return;
    }
    if (!ru && !en && tDates) {
      const currentText = dateEl.textContent.trim();
      if (currentText === 'до 30 Июня' || currentText === 'until June 30' || currentText === 'until 30 June 2026') {
        dateEl.textContent = tDates.block12_price_discount_date_before;
      } else if (currentText === 'с 30 Июня' || currentText === 'from June 30' || currentText === 'from 30 June 2026') {
        dateEl.textContent = tDates.block12_price_discount_date_after;
      } else if (currentText === 'с 1 Июля' || currentText === 'from July 1' || currentText === 'from 1 July 2026') {
        dateEl.textContent = tDates.block12_price_discount_date_after_july;
      }
    }
  });

  // Важно: синхронизируем высоты только после того, как DOM уже обновлён
  // (при смене периода JS мог раньше пересчитать высоты по старому тексту).
  setTimeout(() => {
    syncBlock12PriceHeights();
  }, 0);
}

// Экспортируем функции глобально
window.updateBlock12AgeRanges = updateBlock12AgeRanges;
window.updateBlock12PricesForYear = updateBlock12PricesForYear;
window.toggleBlock12Prices = toggleBlock12Prices;
window.getBlock12CampusSlug = getBlock12CampusSlug;

// Защита цен для кампуса Ташкент на английской версии через MutationObserver
function protectTashkentPrices() {
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  if (lang !== 'en') return; // Защита нужна только для английской версии
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        mutation.target.querySelectorAll?.('.block12_price_with_discount').forEach(priceEl => {
          const priceItem = priceEl.closest('.block12_price_item');
          const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
          
          if (priceCampus === 'tashkent') {
            const currentText = priceEl.textContent.trim();
            // Если цена в UZS, защищаем её
            if (currentText.includes('UZS')) {
              // Проверяем, не пытается ли кто-то заменить UZS на рубли или евро
              if (priceEl.dataset.lastProtectedValue && priceEl.dataset.lastProtectedValue.includes('UZS')) {
                // Если кто-то изменил цену, восстанавливаем защищенное значение
                const protectedValue = priceEl.dataset.lastProtectedValue;
                if (!currentText.includes('UZS') || currentText !== protectedValue) {
                  // Восстанавливаем защищенное значение
                  priceEl.textContent = protectedValue;
                  priceEl.dataset.originalValue = protectedValue;
                  priceEl.dataset.tashkentProcessed = 'true';
                }
              } else {
                // Сохраняем защищенное значение
                priceEl.dataset.lastProtectedValue = currentText;
                priceEl.dataset.originalValue = currentText;
                priceEl.dataset.tashkentProcessed = 'true';
              }
            }
          }
        });
      }
      
      // Также проверяем прямые изменения textContent
      if (mutation.target.classList?.contains('block12_price_with_discount')) {
        const priceEl = mutation.target;
        const priceItem = priceEl.closest('.block12_price_item');
        const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
        
        if (priceCampus === 'tashkent') {
          const currentText = priceEl.textContent.trim();
          // Если цена в UZS, защищаем её
          if (currentText.includes('UZS')) {
            priceEl.dataset.lastProtectedValue = currentText;
            priceEl.dataset.originalValue = currentText;
            priceEl.dataset.tashkentProcessed = 'true';
          } else if (priceEl.dataset.lastProtectedValue && priceEl.dataset.lastProtectedValue.includes('UZS')) {
            // Кто-то пытается заменить UZS на что-то другое - восстанавливаем
            setTimeout(() => {
              if (!priceEl.textContent.trim().includes('UZS')) {
                priceEl.textContent = priceEl.dataset.lastProtectedValue;
                priceEl.dataset.originalValue = priceEl.dataset.lastProtectedValue;
              }
            }, 0);
          }
        }
      }
    });
  });
  
  // Наблюдаем за всеми элементами цен
  const observePrices = () => {
    document.querySelectorAll('.block12_price_with_discount').forEach(priceEl => {
      const priceItem = priceEl.closest('.block12_price_item');
      const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
      
      if (priceCampus === 'tashkent') {
        observer.observe(priceEl, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  };
  
  // Запускаем наблюдение сразу и после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePrices);
  } else {
    observePrices();
  }
  
  // Также наблюдаем за добавлением новых элементов
  const bodyObserver = new MutationObserver(() => {
    observePrices();
  });
  
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Защита цен для кампуса Ташкент через переопределение textContent
function protectTashkentPriceElements() {
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  if (lang !== 'en') return; // Защита нужна только для английской версии
  
  const protectElement = (priceEl) => {
    // Проверяем, что это элемент цены для Ташкента
    const priceItem = priceEl.closest('.block12_price_item');
    const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
    if (priceCampus !== 'tashkent') return;
    
    // Если элемент уже защищен, пропускаем
    if (priceEl.dataset.protected === 'true') return;
    
    // Сохраняем текущее значение, если оно в UZS
    const currentValue = priceEl.textContent.trim();
    if (currentValue.includes('UZS')) {
      // Сохраняем защищенное значение
      const protectedValue = currentValue;
      
      // Переопределяем textContent через Object.defineProperty
      try {
        Object.defineProperty(priceEl, 'textContent', {
          get: function() {
            return this._protectedTextContent || this._textContent || '';
          },
          set: function(value) {
            const newValue = String(value).trim();
            console.log('[protectTashkentPriceElements] Attempting to set value:', newValue, 'for Tashkent price');
            // Если пытаются установить значение без UZS для Ташкента на английской версии, игнорируем
            if (!newValue.includes('UZS') && !newValue.includes('сумов')) {
              console.warn('[protectTashkentPriceElements] Blocked attempt to set non-UZS value:', newValue, 'Restoring:', protectedValue);
              // Восстанавливаем защищенное значение
              this._textContent = protectedValue;
              this._protectedTextContent = protectedValue;
              // Обновляем DOM напрямую
              if (this.firstChild) {
                this.firstChild.textContent = protectedValue;
              } else {
                this.appendChild(document.createTextNode(protectedValue));
              }
              return;
            }
            // Если значение содержит UZS, разрешаем установку
            if (newValue.includes('UZS')) {
              this._textContent = newValue;
              this._protectedTextContent = newValue;
              if (this.firstChild) {
                this.firstChild.textContent = newValue;
              } else {
                this.appendChild(document.createTextNode(newValue));
              }
            } else {
              // Для других значений используем стандартное поведение
              this._textContent = newValue;
              if (this.firstChild) {
                this.firstChild.textContent = newValue;
              } else {
                this.appendChild(document.createTextNode(newValue));
              }
            }
          },
          configurable: true
        });
        
        // Сохраняем защищенное значение
        priceEl._protectedTextContent = protectedValue;
        priceEl._textContent = protectedValue;
        priceEl.dataset.protected = 'true';
        priceEl.dataset.originalValue = protectedValue;
        priceEl.dataset.tashkentProcessed = 'true';
      } catch (e) {
        // Если не удалось переопределить, используем альтернативный метод
        console.warn('Не удалось защитить элемент цены:', e);
      }
    }
  };
  
  // Защищаем все существующие элементы
  document.querySelectorAll('.block12_price_item[data-campus="tashkent"] .block12_price_with_discount').forEach(protectElement);
  
  // Наблюдаем за добавлением новых элементов
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Проверяем сам узел
          if (node.classList && node.classList.contains('block12_price_with_discount')) {
            protectElement(node);
          }
          // Проверяем дочерние элементы
          node.querySelectorAll?.('.block12_price_item[data-campus="tashkent"] .block12_price_with_discount').forEach(protectElement);
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Инициализация block12 при загрузке страницы
// Важно: скрипт в конце body — DOM может быть уже готов, DOMContentLoaded уже сработал
function initBlock12OnLoad() {
  const block12Root = document.getElementById("block12");
  if (!block12Root) return;

  /** Вкладка «Детский сад» / «Школа» по умолчанию на мобильной карусели (задаётся в _tuition: data-default-price-category) */
  function getBlock12DefaultPriceCategory() {
    const v = block12Root.dataset && block12Root.dataset.defaultPriceCategory;
    if (v === "school" || v === "kindergarten") return v;
    return "kindergarten";
  }

  // Важно: не включаем EN-локи "защиты" цен Ташкента.
  // Они фиксировали старое значение и мешали смене периода в селекторе.
  // Функция обновления текста block12_info
  function updateBlock12Info() {
    const block12Info = document.querySelector('.block12_info');
    if (!block12Info) return;
    
    // Получаем текущий язык и переводы
    const currentLang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
    
    if (!t) return;
    
    // При 768px и меньше используем новый формат, при 769px+ - старый
    if (window.innerWidth <= 768) {
      // Новый формат с параграфами и тире (как в accordion)
      block12Info.innerHTML = '<p><strong>' + t.block12_info_header1 + '</strong></p>' +
        '<p style="margin-bottom: 14px;"></p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_1 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_2 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list1_3 + '</p>' +
        '<p style="margin-bottom: 24px;"></p>' +
        '<p><strong>' + t.block12_info_header2 + '</strong></p>' +
        '<p style="margin-bottom: 14px;"></p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_1 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_2 + '</p>' +
        '<p><span class="accordion_dash">—</span>  ' + t.block12_info_list2_3 + '</p>';
    } else {
      // Старый формат - обычный текст
      block12Info.textContent = t.block12_info;
    }
  }

  // Функция добавления data-атрибутов категорий к элементам
  function addCategoryAttributes() {
    const priceItems = document.querySelectorAll('.block12_price_item');
    priceItems.forEach(item => {
      const titleElement = item.querySelector('.block12_price_title');
      if (titleElement) {
        const titleText = titleElement.textContent.toLowerCase();
        if (titleText.includes('детский сад') || titleText.includes('kindergarten') || titleText.includes('Early Years')) {
          item.setAttribute('data-category', 'kindergarten');
        } else {
          item.setAttribute('data-category', 'school');
        }
      }
      
      // Добавляем data-year, если его нет (по умолчанию все годы)
      if (!item.getAttribute('data-year')) {
        item.setAttribute('data-year', '2024-2025,2025-2026,2026-2027');
      }
    });
  }
  
  // Функция фильтрации элементов по категории при 768px
  function filterBlock12ByCategory(category) {
    if (window.innerWidth > 768) return;
    
    // Исключаем клоны из выборки
    const allItems = document.querySelectorAll('.block12_price_item:not(.price-item-clone)');
    const selectedCampus = document.getElementById('block12SelectedCampus');
    const selectedYear = document.getElementById('block12SelectedYear');
    if (!selectedCampus) return;
    
    const currentCampus = selectedCampus.textContent.trim();
    
    // Получаем текущий год (из CMS или из текста селектора)
    let currentYear = window.block12CurrentYear || '2025-2026';
    if (selectedYear) {
      const yearText = selectedYear.textContent.trim();
      const yearMatch = yearText.match(/(\d{4}-\d{4})/);
      if (yearMatch) {
        currentYear = yearMatch[1];
      }
    }

    const campusData = getBlock12CampusSlug(currentCampus) || 'gorki';

    // Данные CMS для текущего периода/кампуса — число групп категорий
    const yearPrices = (block12PricesData && block12PricesData[currentYear]) ? block12PricesData[currentYear] : {};
    const campusPricesArr = Array.isArray(yearPrices[campusData]) ? yearPrices[campusData] : [];
    const groupsByCategoryId = block12GroupsByCategoryId(campusPricesArr);

    const allInfoBlocks = document.querySelectorAll('.block12_price_info:not(.price-item-clone)');
    allInfoBlocks.forEach(block => {
      block.style.display = 'none';
    });

    let visibleCount = 0;
    allItems.forEach(item => {
      if (item.classList.contains('price-item-clone')) {
        return;
      }

      if (item.classList.contains('block12_price_info_mobile')) {
        item.style.display = 'none';
        return;
      }

      if (item.classList.contains('block12_price_info')) {
        const itemCampus = item.getAttribute('data-campus');
        if (itemCampus === campusData) {
          item.style.display = 'flex';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
        return;
      }

      const itemCampus = item.getAttribute('data-campus');
      const itemCategory = item.getAttribute('data-category');
      const itemYear = item.getAttribute('data-year');

      const campusMatch = itemCampus === campusData;
      const categoryMatch = itemCategory === category;
      const yearMatch = !itemYear || itemYear === currentYear || itemYear.split(',').includes(currentYear);
      const itemCategoryId = item.getAttribute('data-category-id');
      const hasData = itemCategoryId && groupsByCategoryId[String(itemCategoryId)] && groupsByCategoryId[String(itemCategoryId)].length;

      if (campusMatch) {
        if (categoryMatch && yearMatch && hasData) {
          item.style.display = 'flex';
          visibleCount++;
        } else {
          item.style.display = 'none';
        }
      } else {
        item.style.display = 'none';
      }
    });
    
    // Центрируем карусель, если элементов всего 2
    const pricesGrid = document.querySelector('.block12_prices_grid');
    if (pricesGrid) {
      if (visibleCount === 2) {
        pricesGrid.classList.add('block12_prices_grid_centered');
      } else {
        pricesGrid.classList.remove('block12_prices_grid_centered');
      }
    }
    
    // Убеждаемся, что block12_price_info отображается после фильтрации
    if (typeof addBlock12InfoItem === 'function') {
      addBlock12InfoItem();
    }
    
    // Переинициализируем слайдер после фильтрации (с задержкой, чтобы избежать множественных переинициализаций)
    if (window.innerWidth <= 768 && typeof window.reinitPriceSlider === 'function') {
      // Используем debounce для предотвращения множественных переинициализаций
      if (window.block12ReinitTimeout) {
        clearTimeout(window.block12ReinitTimeout);
      }
      window.block12ReinitTimeout = setTimeout(() => {
        window.reinitPriceSlider();
        window.block12ReinitTimeout = null;
      }, 150);
    }
  }
  
  // Кампус по умолчанию: из data-default-campus у #block12 (internal_2025: primary, secondary, …),
  // иначе как на главной — Россия → Горки, Узбекистан → Ташкент.
  const serverDefaultCampus = block12Root && block12Root.dataset && block12Root.dataset.defaultCampus;
  const curCountryEl = document.getElementById('curCountry');
  const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
  const defaultCampusId = serverDefaultCampus || (isUzbekistanRegion ? 'tashkent' : 'gorki');
  
  // Функция инициализации цен — вызываем selectBlock12Campus (как при выборе кампуса)
  const initBlock12Prices = () => {
    const selectedCampus = document.getElementById('block12SelectedCampus');
    let initCampus = defaultCampusId;
    if (!serverDefaultCampus && selectedCampus) {
      const slug = getBlock12CampusSlug(selectedCampus.textContent.trim());
      if (slug) initCampus = slug;
    }
    if (typeof selectBlock12Campus === 'function') {
      // Не закрывать выпадашку кампуса: init вызывается по таймерам/load/переводу,
      // иначе class "open" снимается сразу после клика по селектору.
      selectBlock12Campus(initCampus, { keepDropdownOpen: true });
    } else {
      const defaultYear = window.block12CurrentYear || '2025-2026';
      toggleBlock12Prices(initCampus, defaultYear);
      updateBlock12PricesForYear(defaultYear, initCampus);
    }
    syncBlock12PriceHeights();
    addBlock12InfoItem();
  };
  
  // Добавляем информационный блок при загрузке
  addBlock12InfoItem();

  // Block12 City Selector для мобильных устройств (при 1366px и меньше)
  const block12CampusSelectorBtn = document.getElementById("block12CampusSelectorBtn");
  const block12CampusModal = document.getElementById("block12CampusModal");
  const block12SelectedCampus = document.getElementById("block12SelectedCampus");

  const block12CampusNames = {
    skolkovo: "Сколково",
    moscow: "Москва",
    gorki: "Горки",
    spb: "Санкт-Петербург",
    tashkent: "Ташкент"
  };

  // Обновляем ссылки «Подробнее» на страницу цен кампуса при смене кампуса/года
  function updateBlock12TuitionLinks(campusId, periodSlug) {
    const locale = window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\//)?.[0] || '/ru-ru/';
    const links = document.querySelectorAll(`.block12_price_info[data-campus="${campusId}"] .block12_price_info_btn_red`);
    links.forEach(link => {
      const dataLocale = link.getAttribute('data-locale') || locale;
      link.href = `${dataLocale}campuses/${campusId}/tuition-fees/${periodSlug}/`;
      link.setAttribute('data-period-slug', periodSlug);
    });
  }

  function selectBlock12Campus(campusId, opts) {
    if (opts && opts.fromUserClick) {
      window.block12CampusChosenByUser = true;
    }
    // Синхронизируем block12 → block14: при смене кампуса в block12 обновляем и блок «Наша команда»
    window.block14UserSelectedCampus = campusId;
    // Синхронизируем выбор города во всех блоках
    if (typeof window.syncCampusSelection === 'function') {
      window.syncCampusSelection(campusId);
    }
    
    // Получаем текущий выбранный год (из CMS или из селектора)
    const selectedYear = document.getElementById('block12SelectedYear');
    const defaultYear = window.block12CurrentYear || '2025-2026';
    let currentYear = defaultYear;
    if (selectedYear) {
      const yearText = selectedYear.textContent.trim();
      const yearMatch = yearText.match(/(\d{4}-\d{4})/);
      if (yearMatch) {
        currentYear = yearMatch[1];
      } else {
        const currentLang = localStorage.getItem('siteLanguage') || 'ru';
        const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
        const yearSuffix = t && t.block12_year ? t.block12_year : (currentLang === 'en' ? 'year' : 'год');
        selectedYear.textContent = defaultYear + ' ' + yearSuffix;
      }
    }
    
    // Используем переводы в зависимости от текущего языка
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    let campusName = block12CampusNames[campusId] || campusId;
    
    // Если есть переводы, используем их
    if (typeof translations !== 'undefined' && translations[lang]) {
      const t = translations[lang];
      const campusNameMap = {
        'skolkovo': t.campus_name_skolkovo,
        'moscow': t.campus_name_moscow,
        'gorki': t.campus_name_gorki,
        'spb': t.campus_name_spb,
        'tashkent': t.campus_name_tashkent
      };
      if (campusNameMap[campusId]) {
        campusName = campusNameMap[campusId];
      }
    }
    
    if (block12SelectedCampus) {
      block12SelectedCampus.textContent = campusName;
    }
    
    // Закрываем выпадашку только при реальном выборе/синхронизации, не при initBlock12Prices
    if (!opts || !opts.keepDropdownOpen) {
      if (block12CampusModal) {
        block12CampusModal.classList.remove("open");
      }
      if (block12CampusSelectorBtn) {
        block12CampusSelectorBtn.classList.remove("menu-open");
      }
    }
    
    // Переключаем цены для выбранного кампуса и года
    toggleBlock12Prices(campusId, currentYear);
    
    // Обновляем цены для текущего выбранного года
    updateBlock12PricesForYear(currentYear, campusId);
    
    // Обновляем ссылки «Подробнее» на страницу tuition-fees кампуса
    const yearOption = document.querySelector(`.block12_year_option[data-year="${currentYear}"]`);
    const periodSlug = yearOption ? (yearOption.getAttribute('data-slug') || currentYear) : currentYear;
    updateBlock12TuitionLinks(campusId, periodSlug);
    
    // Мобильная вкладка категории: на школьных страницах — «Школа», иначе «Детский сад» (см. data-default-price-category)
    const defaultPriceCat = getBlock12DefaultPriceCategory();
    const categoryButtons = document.querySelectorAll('.block12_category_btn');
    categoryButtons.forEach(btn => {
      btn.classList.remove('block12_category_btn_active');
      if (btn.getAttribute('data-category') === defaultPriceCat) {
        btn.classList.add('block12_category_btn_active');
      }
    });
    
    // Применяем фильтрацию для мобильных
    if (window.innerWidth <= 768) {
      filterBlock12ByCategory(defaultPriceCat);
      addBlock12InfoItem();
    }

    // Фильтруем отзывы родителей по выбранному кампусу
    if (typeof window.filterParentReviewsByCampus === 'function') {
      window.filterParentReviewsByCampus(campusId);
    }

    // Обновляем преподавателей и отзывы в block14 «Наша команда»
    if (typeof window.applyTeachers === 'function') {
      window.applyTeachers(campusId);
    }
    if (typeof window.updateReviewsForCampus === 'function') {
      window.updateReviewsForCampus(campusId);
    }
    if (typeof window.updateBlock14SelectorDisplay === 'function') {
      window.updateBlock14SelectorDisplay(campusId);
    }
  }
  window.selectBlock12Campus = selectBlock12Campus;

  if (block12CampusSelectorBtn && block12CampusModal) {
    document.addEventListener("click", (e) => {
      if (!block12CampusSelectorBtn.contains(e.target) && !block12CampusModal.contains(e.target)) {
        if (block12CampusModal) {
          block12CampusModal.classList.remove("open");
        }
        if (block12CampusSelectorBtn) {
          block12CampusSelectorBtn.classList.remove("menu-open");
        }
      }
    });

    // Не перезаписываем подпись селектора: для страниц с data-default-campus сервер уже выставил
    // кампус (например СПб на primary/secondary). Раньше здесь всегда подставлялись Горки/Ташкент,
    // из‑за чего ломалась синхронизация с карточками и казалось, что смена кампуса «не работает».

    // Обновляем заголовок при загрузке
    setTimeout(() => {
      updateBlock12Info();
    }, 50);
    
    // Показываем карточки цен при загрузке (тот же путь, что при выборе кампуса)
    initBlock12Prices();
    
    // EN: выравнивание подписи/цен (только если кампус по умолчанию не задан с сервера)
    const applyDefaultCampus = () => {
      if (typeof selectBlock12Campus !== 'function') return;
      if (serverDefaultCampus) return;
      const curCountryEl = document.getElementById('curCountry');
      const isUz = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
      selectBlock12Campus(isUz ? 'tashkent' : 'gorki');
    };
    if (!serverDefaultCampus && (window.location.pathname.includes('/en-gb/') || localStorage.getItem('siteLanguage') === 'en')) {
      applyDefaultCampus();
      setTimeout(applyDefaultCampus, 100);
      setTimeout(applyDefaultCampus, 350);
    }
  }

  // Block12 Year Selector для мобильных устройств (при 768px)
  const block12YearSelectorBtn = document.getElementById("block12YearSelectorBtn");
  const block12YearModal = document.getElementById("block12YearModal");
  const block12SelectedYear = document.getElementById("block12SelectedYear");

  // Делегирование на #block12: как на детсаду вся логика в одном бандле; на primary дополнительно
  // грузится public/primary/js/script.js — один обработчик на контейнере устойчивее прямых на кнопках.
  if (!block12Root.dataset.block12TuitionDelegation) {
    block12Root.dataset.block12TuitionDelegation = "1";
    block12Root.addEventListener("click", (e) => {
      if (block12CampusSelectorBtn && block12CampusModal) {
        const campusBtnEl = e.target.closest("#block12CampusSelectorBtn");
        if (campusBtnEl && campusBtnEl === block12CampusSelectorBtn) {
          e.stopPropagation();
          block12CampusModal.classList.toggle("open");
          block12CampusSelectorBtn.classList.toggle("menu-open");
          return;
        }
        const campusOpt = e.target.closest(".block12_campus_option");
        if (campusOpt && block12CampusModal.contains(campusOpt)) {
          e.stopPropagation();
          const campusId = campusOpt.getAttribute("data-campus");
          if (campusId) selectBlock12Campus(campusId, { fromUserClick: true });
          return;
        }
      }
      if (block12YearSelectorBtn && block12YearModal) {
        const yearBtnEl = e.target.closest("#block12YearSelectorBtn");
        if (yearBtnEl && yearBtnEl === block12YearSelectorBtn) {
          e.stopPropagation();
          block12YearModal.classList.toggle("open");
          block12YearSelectorBtn.classList.toggle("menu-open");
          return;
        }
        const yearOpt = e.target.closest(".block12_year_option");
        if (yearOpt && block12YearModal.contains(yearOpt)) {
          e.stopPropagation();
          const year = yearOpt.getAttribute("data-year");
          if (year) selectBlock12Year(year);
        }
      }
    });
  }

  function selectBlock12Year(year) {
    if (block12SelectedYear) {
      const currentLang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
      const yearText = t && t.block12_year ? t.block12_year : (currentLang === 'en' ? 'year' : 'год');
      block12SelectedYear.textContent = year + ' ' + yearText;
    }
    
    // Закрываем модальное окно
    if (block12YearModal) {
      block12YearModal.classList.remove("open");
    }
    
    // Убираем класс menu-open
    if (block12YearSelectorBtn) {
      block12YearSelectorBtn.classList.remove("menu-open");
    }
    
    // Получаем текущий выбранный кампус
    const selectedCampus = document.getElementById('block12SelectedCampus');
    const curCountryEl = document.getElementById('curCountry');
    const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
    let currentCampus = isUzbekistanRegion ? 'tashkent' : 'gorki';
    
    if (selectedCampus) {
      const campusSlug = getBlock12CampusSlug(selectedCampus.textContent.trim());
      if (campusSlug) currentCampus = campusSlug;
    }
    
    // Переключаем видимость блоков с учетом года
    toggleBlock12Prices(currentCampus, year);
    
    // Добавляем фильтрацию по категории при 768px (если нужно)
    if (window.innerWidth <= 768) {
      const activeCategory = document.querySelector('.block12_category_btn_active');
      if (activeCategory) {
        const category = activeCategory.getAttribute('data-category');
        filterBlock12ByCategory(category);
      } else {
        filterBlock12ByCategory(getBlock12DefaultPriceCategory());
      }
    }
    
    // Обновляем цены СРАЗУ после переключения видимости и фильтрации
    updateBlock12PricesForYear(year, currentCampus);
    
    // Обновляем ссылки «Подробнее» на страницу tuition-fees кампуса
    const yearOption = document.querySelector(`.block12_year_option[data-year="${year}"]`);
    const periodSlug = yearOption ? (yearOption.getAttribute('data-slug') || year) : year;
    if (typeof updateBlock12TuitionLinks === 'function') {
      updateBlock12TuitionLinks(currentCampus, periodSlug);
    }
    
    // Переинициализируем слайдер и добавляем информационный блок ПОСЛЕ обновления цен (только для 768px)
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        addBlock12InfoItem();
        if (window.reinitPriceSlider) {
          // Используем debounce для предотвращения множественных переинициализаций
          if (window.block12ReinitTimeout) {
            clearTimeout(window.block12ReinitTimeout);
          }
          window.block12ReinitTimeout = setTimeout(() => {
            window.reinitPriceSlider();
            // Обновляем цены еще раз после переинициализации слайдера, чтобы обновить клоны
            setTimeout(() => {
              updateBlock12PricesForYear(year, currentCampus);
            }, 100);
            window.block12ReinitTimeout = null;
          }, 150);
        }
      }, 10);
    }
  }

  if (block12YearSelectorBtn && block12YearModal) {
    document.addEventListener("click", (e) => {
      if (!block12YearSelectorBtn.contains(e.target) && !block12YearModal.contains(e.target)) {
        if (block12YearModal) {
          block12YearModal.classList.remove("open");
        }
        if (block12YearSelectorBtn) {
          block12YearSelectorBtn.classList.remove("menu-open");
        }
      }
    });

    // Устанавливаем период из CMS по умолчанию (block12SelectedYear уже заполнен сервером)
    if (block12SelectedYear) {
      const currentLang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
      const yearSuffix = t && t.block12_year ? t.block12_year : (currentLang === 'en' ? 'year' : 'год');
      const defaultYear = window.block12CurrentYear || '2025-2026';
      const yearMatch = block12SelectedYear.textContent.trim().match(/(\d{4}-\d{4})/);
      if (!yearMatch) {
        block12SelectedYear.textContent = defaultYear + ' ' + yearSuffix;
      }
      // Обновляем цены для года по умолчанию
      const selectedCampus = document.getElementById('block12SelectedCampus');
      const curCountryEl = document.getElementById('curCountry');
      const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
      let defaultCampus = isUzbekistanRegion ? 'tashkent' : 'gorki';
      if (selectedCampus) {
        const campusSlug = getBlock12CampusSlug(selectedCampus.textContent.trim());
        if (campusSlug) defaultCampus = campusSlug;
      }
      // Для Ташкента на английской версии проверяем, нужно ли обновлять цены
      if (currentLang === 'en' && defaultCampus === 'tashkent') {
        const tashkentPrices = document.querySelectorAll('.block12_price_item[data-campus="tashkent"] .block12_price_with_discount');
        const needsUpdate = tashkentPrices.length === 0 || Array.from(tashkentPrices).some(priceEl => {
          const text = priceEl.textContent.trim();
          return !text.includes('UZS') && !text.includes('сумов');
        });
        if (needsUpdate) {
          updateBlock12PricesForYear(defaultYear, defaultCampus);
        }
      } else {
        updateBlock12PricesForYear(defaultYear, defaultCampus);
      }
    }
  }
  
  // Дополнительный вызов при загрузке страницы для гарантии обновления заголовка
  setTimeout(() => {
    updateBlock12Info();
    addBlock12InfoItem();
    updateBlock12AgeRanges();
    initBlock12Prices();
  }, 300);
  
  // Повторный вызов после загрузки всех ресурсов (важно для /en-gb/)
  window.addEventListener('load', () => {
    setTimeout(() => initBlock12Prices(), 100);
    setTimeout(() => initBlock12Prices(), 400);
    // Дополнительно для EN — страница может загружаться асинхронно
    if (localStorage.getItem('siteLanguage') === 'en' || window.location.pathname.includes('/en-gb/')) {
      setTimeout(() => initBlock12Prices(), 700);
    }
  });
  
  // Синхронизируем высоты при изменении размера окна
  window.addEventListener('resize', () => {
    syncBlock12PriceHeights();
    updateBlock12Info();
    addBlock12InfoItem();
  });
  
  // Обновляем block12_info при изменении языка
  const originalApplyLanguage = window.applyLanguage;
  if (originalApplyLanguage) {
    window.applyLanguage = function(...args) {
      originalApplyLanguage.apply(this, args);
      setTimeout(() => {
        updateBlock12Info();
      }, 100);
    };
  }
  
  // Также обновляем при вызове translatePage — показываем карточки цен после перевода (как на RU)
  const originalTranslatePage = window.translatePage;
  if (originalTranslatePage) {
    window.translatePage = function(...args) {
      originalTranslatePage.apply(this, args);
      const isEn = args[0] === 'en';
      setTimeout(() => {
        updateBlock12Info();
        initBlock12Prices();
        if (isEn && typeof window.selectBlock12Campus === 'function') {
          const curCountryEl = document.getElementById('curCountry');
          const isUz = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
          window.selectBlock12Campus(isUz ? 'tashkent' : 'gorki');
        }
      }, 50);
      if (isEn) setTimeout(() => {
        if (typeof window.selectBlock12Campus === 'function') {
          const curCountryEl = document.getElementById('curCountry');
          const isUz = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
          window.selectBlock12Campus(isUz ? 'tashkent' : 'gorki');
        }
      }, 250);
    };
  }
  
  // Добавляем data-атрибуты при загрузке
  addCategoryAttributes();
  
  // Обработчики кнопок категорий при 768px
  const categoryButtons = document.querySelectorAll('.block12_category_btn');
  categoryButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Работает только при 768px
      if (window.innerWidth > 768) return;
      
      // Убираем активный класс со всех кнопок
      categoryButtons.forEach(b => b.classList.remove('block12_category_btn_active'));
      // Добавляем активный класс на нажатую кнопку
      btn.classList.add('block12_category_btn_active');
      
      // Фильтруем элементы по категории
      const category = btn.getAttribute('data-category');
      filterBlock12ByCategory(category);
    });
  });
  
  // Инициализация фильтрации при загрузке — категория с страницы (internal: школа / early years: детсад)
  if (window.innerWidth <= 768) {
    filterBlock12ByCategory(getBlock12DefaultPriceCategory());
  }
  
  // Обновление при изменении размера окна
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 768) {
      // При 768px - используем фильтрацию по категориям
      const activeCategory = document.querySelector('.block12_category_btn_active');
      if (activeCategory) {
        const category = activeCategory.getAttribute('data-category');
        filterBlock12ByCategory(category);
      } else {
        filterBlock12ByCategory(getBlock12DefaultPriceCategory());
      }
    } else {
      // При 769px+ - возвращаем обычное поведение (показываем все элементы кампуса)
      const selectedCampus = document.getElementById('block12SelectedCampus');
      if (selectedCampus) {
        const campusSlug = getBlock12CampusSlug(selectedCampus.textContent.trim());
        if (campusSlug) toggleBlock12Prices(campusSlug);
      }
    }
  });
  
  // Обновление фильтрации при изменении кампуса - только при 768px
  if (block12SelectedCampus) {
    const campusObserver = new MutationObserver(() => {
      const campusSlug = getBlock12CampusSlug(block12SelectedCampus.textContent.trim());
      if (window.innerWidth <= 768) {
        const activeCategory = document.querySelector('.block12_category_btn_active');
        if (activeCategory) {
          const category = activeCategory.getAttribute('data-category');
          filterBlock12ByCategory(category);
        } else {
          filterBlock12ByCategory(getBlock12DefaultPriceCategory());
        }
      } else {
        // При 769px+ - используем обычную логику
        if (campusSlug) toggleBlock12Prices(campusSlug);
      }
      if (campusSlug && typeof window.filterParentReviewsByCampus === 'function') {
        window.filterParentReviewsByCampus(campusSlug);
      }
    });
    campusObserver.observe(block12SelectedCampus, { childList: true, characterData: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlock12OnLoad);
} else {
  initBlock12OnLoad();
}

// Бесконечная карусель для block12_prices_grid (как slider_container)
// ============================================
(function() {
  let pricesGrid = null;
  let pricesSlides = null;
  let currentPriceIndex = 0;
  let isPriceTransitioning = false;
  let isPriceAnimating = false;
  const priceItemGap = 16; // отступ между элементами (gap из CSS)

  // Функция для получения ширины элемента в зависимости от размера экрана
  function getPriceItemWidth() {
    if (window.innerWidth <= 768) {
      return 270; // ширина для 768px из CSS
    }
    return 270; // можно добавить другие размеры при необходимости
  }

  // Функция для получения шага переключения
  function getPriceItemStep() {
    return getPriceItemWidth() + priceItemGap;
  }

  // Функция для получения времени transition
  function getPriceTransitionDuration() {
    return window.innerWidth >= 1024 ? '0.2s' : '0.4s';
  }

  // Функция для получения времени transition в миллисекундах
  function getPriceTransitionDurationMs() {
    return window.innerWidth >= 1024 ? 200 : 400;
  }

  // Функция для получения реальных элементов (без клонов и только видимые)
  // Включаем block12_price_info в список, чтобы блок "Подробнее" был в одном списке и не пропадал при переключении
  function getRealPriceItems() {
    if (!pricesSlides) return [];
    const allItems = pricesSlides.querySelectorAll(".block12_price_item:not(.price-item-clone)");
    // Фильтруем только видимые элементы (не имеют display: none)
    return Array.from(allItems).filter(item => {
      const style = window.getComputedStyle(item);
      return style.display !== 'none';
    });
  }

  /**
   * Первая карточка в карусели: на вкладке «Школа» — сегмент страницы (data-fee-segment-focus),
   * на вкладке «Детский сад» — data-fee-segment-focus-kindergarten или early_years. Иначе 0.
   */
  function applyBlock12FeeSegmentFocusIndex() {
    const root = document.getElementById("block12");
    const activeCatBtn = document.querySelector(".block12_category_btn_active");
    const tab = activeCatBtn && activeCatBtn.getAttribute("data-category");
    let focus = "";
    if (tab === "school") {
      focus = (root && root.dataset && root.dataset.feeSegmentFocus) || "";
    } else if (tab === "kindergarten") {
      focus =
        (root && root.dataset && root.dataset.feeSegmentFocusKindergarten) || "early_years";
    }
    const realItems = getRealPriceItems();
    if (!realItems.length) return;
    if (!focus) {
      currentPriceIndex = 0;
      return;
    }
    const idx = realItems.findIndex((el) => el.getAttribute("data-fee-segment") === focus);
    currentPriceIndex = idx >= 0 ? idx : 0;
  }
  
  // Количество клонов "перед" (block12_price_info не клонируем)
  function getNumBeforeClones(realItems) {
    return realItems.filter(item => !item.classList.contains('block12_price_info')).length;
  }

  // Функция для клонирования всех элементов
  let isCloning = false;
  function clonePriceItems() {
    // Получаем текущий язык
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    
    // Клонирование только на мобильных устройствах (≤768px)
    if (window.innerWidth > 768) {
      // На десктопе удаляем все клоны, если они есть
      const oldClones = pricesSlides ? pricesSlides.querySelectorAll(".price-item-clone") : [];
      oldClones.forEach(clone => {
        if (clone && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      return;
    }
    
    // Защита от множественных одновременных вызовов
    if (isCloning) return;
    isCloning = true;
    
    try {
      // Сначала удаляем все старые клоны синхронно
      const oldClones = pricesSlides.querySelectorAll(".price-item-clone");
      oldClones.forEach(clone => {
        if (clone && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });

      // Получаем реальные элементы после удаления клонов (без информационных блоков)
      const realItems = getRealPriceItems();
      if (realItems.length === 0) {
        isCloning = false;
        return;
      }

      // Клонируем все элементы и добавляем перед первым (исключая информационные блоки)
      const fragmentBefore = document.createDocumentFragment();
      realItems.forEach(item => {
        // НЕ клонируем информационные блоки
        if (item.classList.contains('block12_price_info')) {
          return;
        }
        const clone = item.cloneNode(true);
        clone.classList.add("price-item-clone");
        
        // Для Ташкента на английской версии: защищаем цены в клонированных элементах
        if (lang === 'en') {
          const clonePriceElements = clone.querySelectorAll('.block12_price_with_discount');
          clonePriceElements.forEach(priceEl => {
            const priceItem = priceEl.closest('.block12_price_item');
            const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
            if (priceCampus === 'tashkent') {
              const currentText = priceEl.textContent.trim();
              if (currentText.includes('UZS')) {
                priceEl.dataset.originalValue = currentText;
                priceEl.dataset.tashkentProcessed = 'true';
              } else if (currentText.includes('сумов')) {
                const sumsMatch = currentText.match(/([\d\s]+)\s*сумов/);
                if (sumsMatch) {
                  const sumsAmount = sumsMatch[1].trim();
                  const uzsValue = `${sumsAmount} UZS`;
                  priceEl.textContent = uzsValue;
                  priceEl.dataset.originalValue = uzsValue;
                  priceEl.dataset.tashkentProcessed = 'true';
                }
              }
            }
          });
        }
        
        fragmentBefore.appendChild(clone);
      });
      if (realItems[0] && realItems[0].parentNode && fragmentBefore.hasChildNodes()) {
        realItems[0].parentNode.insertBefore(fragmentBefore, realItems[0]);
      }

      // Клонируем все элементы и добавляем после последнего (исключая информационные блоки)
      const lastRealItem = realItems[realItems.length - 1];
      if (lastRealItem && lastRealItem.parentNode) {
        realItems.forEach(item => {
          // НЕ клонируем информационные блоки
          if (item.classList.contains('block12_price_info')) {
            return;
          }
          const clone = item.cloneNode(true);
          clone.classList.add("price-item-clone");
          
          // Для Ташкента на английской версии: защищаем цены в клонированных элементах
          if (lang === 'en') {
            const clonePriceElements = clone.querySelectorAll('.block12_price_with_discount');
            clonePriceElements.forEach(priceEl => {
              const priceItem = priceEl.closest('.block12_price_item');
              const priceCampus = priceItem ? priceItem.getAttribute('data-campus') : '';
              if (priceCampus === 'tashkent') {
                const currentText = priceEl.textContent.trim();
                if (currentText.includes('UZS')) {
                  priceEl.dataset.originalValue = currentText;
                  priceEl.dataset.tashkentProcessed = 'true';
                } else if (currentText.includes('сумов')) {
                  const sumsMatch = currentText.match(/([\d\s]+)\s*сумов/);
                  if (sumsMatch) {
                    const sumsAmount = sumsMatch[1].trim();
                    const uzsValue = `${sumsAmount} UZS`;
                    priceEl.textContent = uzsValue;
                    priceEl.dataset.originalValue = uzsValue;
                    priceEl.dataset.tashkentProcessed = 'true';
                  }
                }
              }
            });
          }
          
          lastRealItem.parentNode.appendChild(clone);
        });
      }
    } catch (error) {
      console.error('Error in clonePriceItems:', error);
    } finally {
      isCloning = false;
    }
  }

  // Функция для обновления позиции слайдера
  function updatePriceSlider() {
    if (!pricesSlides || !pricesGrid) return;
    
    const realItems = getRealPriceItems();
    if (realItems.length === 0) return;

    // Ограничиваем индекс реальными элементами
    if (currentPriceIndex < 0) {
      currentPriceIndex = 0;
    }
    if (currentPriceIndex >= realItems.length) {
      currentPriceIndex = realItems.length - 1;
    }

    // Всегда центрируем относительно центра viewport на мобильных
    const centerX = window.innerWidth / 2;
    const containerRect = pricesGrid.getBoundingClientRect();
    const containerLeft = containerRect.left;

    const currentItemWidth = getPriceItemWidth();
    const currentItemStep = getPriceItemStep();
    const itemCenterX = currentItemWidth / 2;
    const numBeforeClones = getNumBeforeClones(realItems);
    const realItemIndexInDOM = numBeforeClones + currentPriceIndex;
    const activeItemLeftPosition = realItemIndexInDOM * currentItemStep;
    const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;

    // Всегда центрируем карточку относительно центра экрана
    const translateX = centerX - containerLeft - activeItemCenterPosition;

    // Добавляем плавную анимацию, если не идет переход через клоны
    if (!isPriceTransitioning) {
      pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
    }
    pricesSlides.style.transform = `translateX(${translateX}px)`;
  }

  // Функция для перехода на следующий элемент
  function goToNextPriceItem() {
    if (isPriceAnimating) return;
    
    const realItems = getRealPriceItems();
    const realItemsCount = realItems.length;
    
    if (currentPriceIndex < realItemsCount - 1) {
      // Обычный переход на следующий элемент
      isPriceAnimating = true;
      currentPriceIndex++;
      if (pricesSlides.style.transition === 'none') {
        pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      }
      updatePriceSlider();
      
      setTimeout(() => {
        isPriceAnimating = false;
      }, getPriceTransitionDurationMs());
    } else {
      // Переход с последнего на первый через клон
      if (isPriceTransitioning || isPriceAnimating) return;
      isPriceTransitioning = true;
      isPriceAnimating = true;
      
      const numBeforeClones = getNumBeforeClones(realItems);
      const firstCloneIndex = numBeforeClones + realItemsCount;
      const currentItemStep = getPriceItemStep();
      const currentItemWidth = getPriceItemWidth();
      const itemCenterX = currentItemWidth / 2;
      const activeItemLeftPosition = firstCloneIndex * currentItemStep;
      const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
      
      // Всегда центрируем относительно центра viewport
      const viewportCenter = window.innerWidth / 2;
      const containerRect = pricesGrid.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const translateX = viewportCenter - containerLeft - activeItemCenterPosition;
      
      pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      pricesSlides.style.transform = `translateX(${translateX}px)`;
      
      setTimeout(() => {
        pricesSlides.style.transition = 'none';
        currentPriceIndex = 0;
        updatePriceSlider();
        requestAnimationFrame(() => {
          setTimeout(() => {
            isPriceTransitioning = false;
            isPriceAnimating = false;
            pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getPriceTransitionDurationMs());
    }
  }

  // Функция для перехода на предыдущий элемент
  function goToPrevPriceItem() {
    if (isPriceAnimating) return;
    
    const realItems = getRealPriceItems();
    const realItemsCount = realItems.length;
    
    if (currentPriceIndex > 0) {
      // Обычный переход на предыдущий элемент
      isPriceAnimating = true;
      currentPriceIndex--;
      if (pricesSlides.style.transition === 'none') {
        pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      }
      updatePriceSlider();
      
      setTimeout(() => {
        isPriceAnimating = false;
      }, getPriceTransitionDurationMs());
    } else {
      // Переход с первого на последний через клон
      if (isPriceTransitioning || isPriceAnimating) return;
      isPriceTransitioning = true;
      isPriceAnimating = true;
      
      const numBeforeClones = getNumBeforeClones(realItems);
      const lastCloneIndex = numBeforeClones - 1;
      const currentItemStep = getPriceItemStep();
      const currentItemWidth = getPriceItemWidth();
      const itemCenterX = currentItemWidth / 2;
      const activeItemLeftPosition = lastCloneIndex * currentItemStep;
      const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
      
      // Всегда центрируем относительно центра viewport
      const viewportCenter = window.innerWidth / 2;
      const containerRect = pricesGrid.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const translateX = viewportCenter - containerLeft - activeItemCenterPosition;
      
      pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
      pricesSlides.style.transform = `translateX(${translateX}px)`;
      
      setTimeout(() => {
        pricesSlides.style.transition = 'none';
        currentPriceIndex = realItemsCount - 1;
        updatePriceSlider();
        requestAnimationFrame(() => {
          setTimeout(() => {
            isPriceTransitioning = false;
            isPriceAnimating = false;
            pricesSlides.style.transition = `transform ${getPriceTransitionDuration()} cubic-bezier(0.4, 0, 0.2, 1)`;
          }, 0.0001);
        });
      }, getPriceTransitionDurationMs());
    }
  }

  // Функция для вычисления начальной позиции
  function getInitialPriceTranslate() {
    const realItems = getRealPriceItems();
    const centerX = window.innerWidth / 2;
    const containerRect = pricesGrid.getBoundingClientRect();
    const containerLeft = containerRect.left;
    const currentItemWidth = getPriceItemWidth();
    const currentItemStep = getPriceItemStep();
    const itemCenterX = currentItemWidth / 2;
    const numBeforeClones = getNumBeforeClones(realItems);
    const realItemIndexInDOM = numBeforeClones + currentPriceIndex;
    const activeItemLeftPosition = realItemIndexInDOM * currentItemStep;
    const activeItemCenterPosition = activeItemLeftPosition + itemCenterX;
    
    // Всегда центрируем относительно центра viewport
    return centerX - containerLeft - activeItemCenterPosition;
  }

  // Инициализация
  function initPriceSlider() {
    pricesGrid = document.getElementById('block12PricesGrid');
    pricesSlides = document.getElementById('block12PricesSlides');
    
    if (!pricesGrid || !pricesSlides) return;

    // Проверяем, что есть видимые элементы
    const realItems = getRealPriceItems();
    if (realItems.length === 0) return;

    // Инициализируем слайдер только на мобильных (768px и меньше)
    if (window.innerWidth <= 768) {
      clonePriceItems();
      applyBlock12FeeSegmentFocusIndex();
      updatePriceSlider();

      // Обработчики для свайпов (мышь)
      let isDragging = false;
      let startX = 0;
      let currentX = 0;
      let initialTranslate = 0;

      pricesSlides.addEventListener("mousedown", (e) => {
        if (isPriceTransitioning || isPriceAnimating) return;
        isDragging = true;
        startX = e.clientX;
        initialTranslate = getInitialPriceTranslate();
        pricesSlides.classList.add("dragging");
        e.preventDefault();
      });

      pricesSlides.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        currentX = e.clientX - startX;
        pricesSlides.style.transform = `translateX(${initialTranslate + currentX}px)`;
      });

      pricesSlides.addEventListener("mouseup", () => {
        if (!isDragging) return;
        isDragging = false;
        pricesSlides.classList.remove("dragging");
        
        const threshold = getPriceItemStep() / 6;
        if (Math.abs(currentX) > threshold) {
          if (currentX > 0) {
            goToPrevPriceItem();
          } else {
            goToNextPriceItem();
          }
        } else {
          updatePriceSlider();
        }
        currentX = 0;
      });

      pricesSlides.addEventListener("mouseleave", () => {
        if (isDragging) {
          isDragging = false;
          pricesSlides.classList.remove("dragging");
          updatePriceSlider();
          currentX = 0;
        }
      });

      // Обработчики для свайпов (тач)
      let touchStartX = 0;
      let touchStartY = 0;
      let touchCurrentX = 0;
      let touchInitialTranslate = 0;

      pricesSlides.addEventListener("touchstart", (e) => {
        if (isPriceTransitioning || isPriceAnimating) return;
        isDragging = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchInitialTranslate = getInitialPriceTranslate();
        pricesSlides.classList.add("dragging");
      });

      pricesSlides.addEventListener("touchmove", (e) => {
        if (!isDragging) return;
        touchCurrentX = e.touches[0].clientX - touchStartX;
        const touchCurrentY = e.touches[0].clientY - touchStartY;
        
        if (Math.abs(touchCurrentX) > Math.abs(touchCurrentY) && Math.abs(touchCurrentX) > 5) {
          e.preventDefault();
        }
        
        if (window.innerWidth > 1023) {
          pricesSlides.style.transform = `translateX(${touchInitialTranslate + touchCurrentX}px)`;
        }
      });

      pricesSlides.addEventListener("touchend", () => {
        if (!isDragging) return;
        isDragging = false;
        pricesSlides.classList.remove("dragging");
        
        const threshold = getPriceItemStep() / 6;
        if (Math.abs(touchCurrentX) > threshold) {
          if (touchCurrentX > 0) {
            goToPrevPriceItem();
          } else {
            goToNextPriceItem();
          }
        } else {
          updatePriceSlider();
        }
        touchCurrentX = 0;
      });

      // Обновление при изменении размера окна
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth <= 768) {
            clonePriceItems();
            applyBlock12FeeSegmentFocusIndex();
            updatePriceSlider();
          } else {
            // На десктопе возвращаем обычный скролл
            const oldClones = pricesSlides.querySelectorAll(".price-item-clone");
            oldClones.forEach(clone => clone.remove());
            pricesSlides.style.transform = '';
            pricesSlides.style.transition = '';
            currentPriceIndex = 0;
          }
        }, 100);
      });
    }
  }

  // Публичная функция для переинициализации слайдера
  window.reinitPriceSlider = function() {
    if (window.innerWidth <= 768 && pricesSlides && pricesGrid) {
      const realItems = getRealPriceItems();
      if (realItems.length > 0) {
        clonePriceItems();
        applyBlock12FeeSegmentFocusIndex();
        updatePriceSlider();
      }
    } else if (window.innerWidth > 768 && pricesSlides) {
      // На десктопе удаляем все клоны
      const oldClones = pricesSlides.querySelectorAll(".price-item-clone");
      oldClones.forEach(clone => {
        if (clone && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
    }
  };

  // Инициализация при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceSlider);
  } else {
    initPriceSlider();
  }

  // Переинициализация при изменении видимости элементов (при смене кампуса/года/категории)
  let isUpdating = false;
  let updateTimeout = null;
  let lastVisibleCount = 0;
  
  const observer = new MutationObserver((mutations) => {
    // Предотвращаем бесконечный цикл
    if (isUpdating) return;
    
    // Игнорируем изменения в клонах
    const hasNonCloneChanges = mutations.some(mutation => {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const removedNodes = Array.from(mutation.removedNodes);
        const allNodes = [...addedNodes, ...removedNodes];
        return allNodes.some(node => {
          if (node.nodeType === 1) {
            return !node.classList.contains('price-item-clone') &&
                   !node.querySelector('.price-item-clone');
          }
          return false;
        });
      }
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        return !target.classList.contains('price-item-clone') &&
               !target.closest('.price-item-clone');
      }
      return true;
    });
    
    if (!hasNonCloneChanges) return;
    
    if (window.innerWidth <= 768 && pricesSlides) {
      // Проверяем, действительно ли изменилось количество видимых элементов
      const realItems = getRealPriceItems();
      const currentVisibleCount = realItems.length;
      
      // Если количество видимых элементов не изменилось, игнорируем
      if (currentVisibleCount === lastVisibleCount && currentVisibleCount > 0) {
        return;
      }
      
      lastVisibleCount = currentVisibleCount;
      
      // Используем debounce для предотвращения множественных вызовов
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        if (!isUpdating && currentVisibleCount > 0) {
          isUpdating = true;
          // Временно отключаем observer
          observer.disconnect();
          
          // Сохраняем текущую позицию перед переинициализацией
          const savedIndex = currentPriceIndex;
          
          clonePriceItems();
          
          // Восстанавливаем позицию, если она была не на первом элементе
          // и если количество элементов не изменилось значительно
          if (savedIndex > 0 && savedIndex < currentVisibleCount) {
            currentPriceIndex = savedIndex;
          } else {
            applyBlock12FeeSegmentFocusIndex();
          }
          
          updatePriceSlider();
          
          // Включаем observer обратно
          setTimeout(() => {
            isUpdating = false;
            if (pricesGrid) {
              observer.observe(pricesGrid, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
              });
            }
          }, 50);
        }
      }, 200);
    }
  });

  // Наблюдаем за изменениями в block12_prices_grid
  const observePricesGrid = () => {
    pricesGrid = document.getElementById('block12PricesGrid');
    if (pricesGrid) {
      observer.observe(pricesGrid, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePricesGrid);
  } else {
    observePricesGrid();
  }

  // Переопределяем window.reinitPriceSlider для добавления защиты от множественных вызовов
  const originalReinitPriceSlider = window.reinitPriceSlider;
  window.reinitPriceSlider = function() {
    // Предотвращаем множественные переинициализации
    if (window.block12ReinitInProgress) {
      return;
    }
    window.block12ReinitInProgress = true;
    
    // Вызываем оригинальную функцию
    if (originalReinitPriceSlider && typeof originalReinitPriceSlider === 'function') {
      originalReinitPriceSlider();
    } else {
      // Если оригинальной функции нет, используем базовую логику
      if (window.innerWidth <= 768 && pricesSlides && pricesGrid) {
        const realItems = getRealPriceItems();
        if (realItems.length > 0) {
          clonePriceItems();
          applyBlock12FeeSegmentFocusIndex();
          updatePriceSlider();
        }
      } else if (window.innerWidth > 768 && pricesSlides) {
        // На десктопе удаляем все клоны
        const oldClones = pricesSlides.querySelectorAll(".price-item-clone");
        oldClones.forEach(clone => {
          if (clone && clone.parentNode) {
            clone.parentNode.removeChild(clone);
          }
        });
      }
    }
    
    // Снимаем флаг после небольшой задержки
    setTimeout(() => {
      window.block12ReinitInProgress = false;
    }, 200);
  };
})();
